/**
 *
 * @param {{}} [typeMap]
 * @returns {TypeMap}
 */
function toTypeMap(typeMap = {}) {
  return Object.fromEntries(Object.entries(typeMap)
    .map(([key, value]) => ([key, { id: value.typeId, name: value.typeName }])));
}

/**
 * @returns {Type[]}
 */
function orderTypesBySeqNumber(typeMap = {}, typeIds = []) {
  return typeIds.length > 1 ? typeIds.map((typeId) => typeMap[typeId]) : Object.values(typeMap);
}

/**
 * @param {Type[]} typeArray
 * @param {number | undefined} selectedTypeId
 * @param {boolean} defaultToFirst
 * @returns {number | null}
 */
function getSelectedTypeId(typeArray, selectedTypeId, defaultToFirst) {
  if (typeof selectedTypeId === 'number') {
    return selectedTypeId;
  }
  return defaultToFirst ? typeArray[0]?.id ?? null : null;
}

/**
 *
 * @param {Product} product
 * @param {{defaultToFirst: boolean}} options
 * @returns {ParsedTypes}
 */
module.exports = function parser(product, options = { defaultToFirst: false }) {
  const types = product?.traits?.types;
  const { typeMap: origTypeMap, orderedTypesBySeqNumber, selectedType } = types || { typeMap: {} };

  const typeMap = toTypeMap(origTypeMap);
  const typeArray = orderTypesBySeqNumber(typeMap, orderedTypesBySeqNumber);

  const selectedTypeId = getSelectedTypeId(typeArray, selectedType, options.defaultToFirst);

  return {
    selectedTypeId,
    typeMap,
    typeArray,
  };
};
